export default function isActiveCollectionChanged(changedTagsIds, activeCollectionIdsArg) {
  return changedTagsIds.findIndex((changedTagId) => activeCollectionIdsArg.includes(changedTagId)) > -1;
}
